import { Component, OnInit, Inject } from '@angular/core';
import { ToolsService } from 'src/app/services/tools/tools.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import {SalemethodService} from "../../../services/api/salemethod/salemethod.service";

@Component({
  selector: 'app-alert-mini-amount',
  templateUrl: './alert-mini-amount.component.html',
  styleUrls: ['./alert-mini-amount.component.css']
})
export class AlertMiniAmountComponent implements OnInit {

  miniAmount: number|any;

  currSm: any = this.tools.getStor(SalemethodService.TAG_STORAGE);

  url: string = this.router.url;

  innerHeight: number = window.innerHeight;

  constructor(
    @Inject(MAT_DIALOG_DATA) data:any,
    private dialog: MatDialogRef<AlertMiniAmountComponent>,
    private tools: ToolsService,
    private router: Router
  ) { }

  ngOnInit() {
    this.setMiniAmount();
  }


  setMiniAmount() {
    this.miniAmount = parseFloat(this.currSm.minimum_order);
  }

  closeDial() {
    let splitUrl = this.url.split("/");
    splitUrl[1] === 'endorder' ? this.goProduct() : this.dialog.close();
  }

  goProduct() {

    this.tools.goProductPage();

    this.dialog.close();
  }




}
